import './globalShim';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { App } from './App';
import { AuthProvider } from './core/authContext';
import { initAWSAmplify } from './core/awsAmplify';
import { canonicalRedirectTarget } from './core/canonicalHost';
import { theme } from './theme';

const redirect = canonicalRedirectTarget(
  window.location,
  import.meta.env.REACT_APP_CANONICAL_URL as string | undefined
);

if (redirect) {
  window.location.replace(redirect);
} else {
  initAWSAmplify();

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found.');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </StrictMode>
  );
}
